export default __webpack_public_path__ + "static/media/link-icon-secondary-color.35049281.svg";